import { render, staticRenderFns } from "./backManageTab.vue?vue&type=template&id=f6dc4326&scoped=true"
import script from "./backManageTab.vue?vue&type=script&lang=js"
export * from "./backManageTab.vue?vue&type=script&lang=js"
import style0 from "./backManageTab.vue?vue&type=style&index=0&id=f6dc4326&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dc4326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6dc4326')) {
      api.createRecord('f6dc4326', component.options)
    } else {
      api.reload('f6dc4326', component.options)
    }
    module.hot.accept("./backManageTab.vue?vue&type=template&id=f6dc4326&scoped=true", function () {
      api.rerender('f6dc4326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traceback/videoManage/backManageTab.vue"
export default component.exports